<template>
  <div>
    <p class="sw-intro">
      {{ t('Cuéntenos qué necesita y la notaría le contactará para prepararlo. Le llevará unos minutos y no hace falta registrarse.') }}
    </p>
    <div v-if="!tipos.length" class="sw-cargando" role="status">
      <v-progress-circular indeterminate size="22" width="2" class="mr-3" />
      {{ t('Cargando encargos…') }}
    </div>
    <div v-else class="sw-opciones sw-opciones--tipos" role="radiogroup" :aria-label="t('Encargo')">
      <button v-for="op in tipos" :key="op.codigo" type="button" class="sw-opcion" role="radio"
        :aria-checked="estado.tipoOperacion === op.codigo"
        :class="{ activo: estado.tipoOperacion === op.codigo }"
        @click="elegir(op.codigo)">
        <v-icon class="sw-opcion__icono">{{ op.icono }}</v-icon>
        <span class="sw-opcion__titulo">{{ op.nombre }}</span>
        <span class="sw-opcion__texto">{{ op.descripcion }}</span>
        <span v-if="videoconferenciaEn(op.codigo)" class="sw-etiqueta-video">
          <v-icon size="14">mdi-video-outline</v-icon> {{ t('Se puede firmar por videoconferencia') }}
        </span>
      </button>
    </div>
    <p v-if="errores['tipoOperacion']" class="sw-error">{{ errores['tipoOperacion'] }}</p>
  </div>
</template>

<script setup lang="ts">
import { t } from '../../composables/solicitudTextos'
import { useSolicitudWeb } from '../../composables/useSolicitudWeb'
const { estado, errores, tipos, elegirTipo, limpiarError, siguiente, pasoActual, videoconferenciaEn } = useSolicitudWeb()
let temporizador: ReturnType<typeof setTimeout> | null = null

/** Al elegir el trámite se pasa al siguiente paso, tras una pausa breve para que se vea la selección. */
function elegir(codigo: string) {
  elegirTipo(codigo)
  limpiarError('tipoOperacion')
  if (temporizador) clearTimeout(temporizador)
  // Solo avanza si sigue en este paso (evita saltos dobles con doble clic)
  temporizador = setTimeout(() => { if (pasoActual.value === 'tipo') siguiente() }, 280)
}
</script>

<style lang="scss">
/* Trámites que se pueden firmar por videoconferencia. Ref: https://trello.com/c/dc7kKk4R */
.sw-etiqueta-video { display: inline-flex; align-items: center; gap: 4px; margin-top: 6px; font-size: 0.8rem; font-weight: 600;
  color: rgb(var(--v-theme-primary)); .v-icon { color: inherit !important; } }
</style>
